<template>
  <div id="genericReport">
    <!-- TABELA PRINCIPAL -->
    <div class="overflow-x-auto border border-slate-200 rounded-xl mb-8">
      <table class="w-full text-left border-collapse min-w-[1000px]">
        <thead>
          <tr class="bg-slate-800 text-white">
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Mês</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Setor</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Veículo</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Placa</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Hod/Hor</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Combustível</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Litros</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">KM I/F</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Percorrido</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Total R$</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-center">Tipo</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider text-right">Média</th>
          </tr>
        </thead>
        <tbody v-if="data && data.result">
          <tr v-for="(value, index) in data.result" :key="index" class="border-b border-slate-100 hover:bg-slate-50 transition-colors">
            <td class="p-3 text-[10px] font-bold text-slate-600 border-r border-slate-100 uppercase">{{ value.month }}</td>
            <td class="p-3 text-[10px] text-slate-600 border-r border-slate-100 uppercase">{{ value.sec_name || '---' }}</td>
            <td class="p-3 text-[10px] text-slate-700 border-r border-slate-100">
               <div class="font-bold uppercase">{{ value.brand_desc }}</div>
               <div class="text-[9px] text-slate-400 uppercase">{{ value.model_desc }}</div>
            </td>
            <td class="p-3 text-[10px] font-black text-orange-600 border-r border-slate-100">{{ value.vehicle_board }}</td>
            <td class="p-3 text-[10px] text-slate-500 border-r border-slate-100 text-center">{{ value.hodometro_horimetro || '---' }}</td>
            <td class="p-3 text-[10px] text-slate-600 border-r border-slate-100 font-medium uppercase">{{ value.item_description_desc }}</td>
            <td class="p-3 text-[10px] font-bold text-slate-800 border-r border-slate-100 text-right">
              {{ value.totalLiters ? realMask(value.totalLiters.toFixed(2)) : '0,00' }}
            </td>
            <td class="p-3 text-[9px] text-slate-400 border-r border-slate-100 text-right">
              {{ value.firsKm || 0 }} / {{ value.lastKm || 0 }}
            </td>
            <td class="p-3 text-[10px] font-bold text-slate-700 border-r border-slate-100 text-right">
              {{ value.travaled || 0 }}
            </td>
            <td class="p-3 text-[10px] font-black text-slate-900 border-r border-slate-100 text-right font-mono">
              R$ {{ value.totalValue ? realMask(value.totalValue.toFixed(2)) : '0,00' }}
            </td>
            <td class="p-3 text-[9px] text-slate-400 border-r border-slate-100 text-center uppercase">
              {{ value.consumption_desc || '---' }}
            </td>
            <td class="p-3 text-[10px] font-black text-orange-600 text-right">
              {{ value.average || '0.00' }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="12" class="p-12 text-center text-slate-400 italic">Nenhum dado encontrado para o período selecionado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- TOTAIS GERAIS -->
    <div v-if="data && data.finalTotals" class="flex justify-end">
      <div class="bg-slate-800 rounded-2xl px-10 py-6 flex gap-12 items-center shadow-xl border border-slate-700">
        <div class="flex flex-col">
          <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">CUMULATIVO LITROS</span>
          <span class="text-2xl font-black text-white text-right">
            {{ data.finalTotals.totalLiters ? realMask(data.finalTotals.totalLiters.toFixed(2)) : '0,00' }} L
          </span>
        </div>
        <div class="w-px h-12 bg-slate-700"></div>
        <div class="flex flex-col">
          <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">CUMULATIVO VALOR</span>
          <span class="text-2xl font-black text-orange-400 text-right font-mono">
            R$ {{ data.finalTotals.totalValue ? realMask(data.finalTotals.totalValue.toFixed(2)) : '0,00' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  methods: {
    initialize() {
      // mixin compatibility
    },
  },
};
</script>

<style scoped>
@media print {
  #genericReport {
    padding: 0 !important;
  }
}
</style>
